@if (!isLoading && insuranceFlowData) {
  <div class="d-flex gap-2 align-items-center">
    <button
      type="button"
      class="lty-btn lty-btn-white d-flex align-items-center gap-1"
      (click)="copyLink()"
      i18n-title
      title="Copier le lien de la tâche"
    >
      <app-copy-icon height="16px" width="16px" />
      <ng-container i18n>Copier le lien</ng-container>
    </button>

    @if (policy && policy.proposalState === 'POLICY_CREATED' && canEdit) {
      <button
        class="lty-btn lty-btn-primary"
        (click)="leadModal.openModal()"
        i18n
      >
        Nouvelle demande
      </button>

      <app-add-lead-modal
        [customerId]="policy.memberDetails.memberId!"
        [memberId]="policy.familyMemberDetails.familyMemberId!"
        [originalProposalId]="policy.proposalId"
        [navigateOnSuccess]="false"
        #leadModal
        (leadCreated)="leadCreated.emit($event)"
      />
    }
  </div>
}
